module.exports = __webpack_public_path__ + "static/media/badge-prestashop.8a70ee70.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-prestashop.png
// module id = 300
// module chunks = 0